<script>
    import {_} from '../lib/i18n';
</script>

<header class="header header_auth">
    <div class="container">
        <a href="/" class="header__logo-wrapper">
            <div class="header__logo-img">
                <img src={$_('header.logoSmall')} />
            </div>
            <div class="header__logo-text">
                <img src={$_('header.logo')} />
            </div>
        </a>
    </div>
</header>

<style>
    @media (min-width: 1114px) {
        .header__logo-img {
            display: none!important;
        }
    }
    @media (max-width: 1113px) {
        .header__logo-text {
            display: none!important;
        }
    }
</style>